 ///////////////////////////////// Ce fichier pour les fonction qui se répète par tous/////////////////////////////////////////
 
 // Fonction pour formater le nombre avec des séparateurs de milliers et arrondir à 2 chiffres après la virgule
 export const formatAllType = (value) => {
    let valueConvert = Number(value);
    return new Intl.NumberFormat('fr-FR', {  
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(valueConvert);  
  };

  //Cette Fonction pour formater la Date
  export const FormatageDate = (date) =>{
    const formattedDate = date.toLocaleDateString('fr-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }) + ' ' + date.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit', // Include seconds
      hour12: false // To ensure 24-hour format
    });
    return formattedDate ;
  }

  
  
 // Fonction pour la calcule de la montant TTC conçu pour le fournisseur
  export const CalculeTTC = (montantCommValue, htValue, commissionValue, tvaValue) => {
    let commission = (montantCommValue / 100) * commissionValue;
    let htC = commission + htValue  ;
    let tva = (htC / 100 ) *  tvaValue;
    let totalTTC = htC  + tva  ;
  
    return totalTTC;
  };




 









  

/**
 * Diagnostic d'un SIRET, identique à celui du serveur (SiretValidator).
 *
 * Sert uniquement au retour visuel à la saisie : la validation qui fait foi est
 * côté API. Sans cet indicateur, on saisit quatorze chiffres sans savoir s'ils
 * sont bons avant l'échec d'une transmission, des semaines plus tard.
 *
 * Un SIREN de neuf chiffres est « incomplet », pas « invalide » : il se complète
 * par les cinq chiffres de l'établissement, il ne se corrige pas.
 */
export const diagnostiquerSiret = (valeur) => {
  const brut = String(valeur ?? "").trim();
  const chiffres = brut.replace(/\D/g, "");

  // Champ vide : rien à signaler. Champ rempli sans aucun chiffre : c'est une
  // saisie invalide, pas une absence — le serveur dit la même chose.
  if (brut === "") return { etat: "absent", message: "" };
  if (chiffres === "") {
    return { etat: "invalide", message: "Le SIRET doit contenir 14 chiffres." };
  }
  if (![9, 14].includes(chiffres.length)) {
    return { etat: "invalide", message: "Le SIRET doit contenir 14 chiffres." };
  }

  // Clé de Luhn : un chiffre sur deux en partant de la droite est doublé,
  // et réduit de 9 s'il dépasse 9.
  let somme = 0;
  for (let i = 0; i < chiffres.length; i++) {
    let c = Number(chiffres[chiffres.length - 1 - i]);
    if (i % 2 === 1) {
      c *= 2;
      if (c > 9) c -= 9;
    }
    somme += c;
  }

  // La Poste fait exception à Luhn : somme des chiffres multiple de 5.
  const laPoste = chiffres.startsWith("356000000") && chiffres.length === 14;
  const cleOk = laPoste
    ? chiffres.split("").reduce((t, c) => t + Number(c), 0) % 5 === 0
    : somme % 10 === 0;

  if (!cleOk) {
    return { etat: "invalide", message: "Clé de contrôle invalide — vérifier les chiffres saisis." };
  }

  return chiffres.length === 9
    ? { etat: "incomplet", message: "SIREN seul — compléter en SIRET (14 chiffres)." }
    : { etat: "valide", message: "SIRET valide." };
};
